export default "__VITE_ASSET__sRKxPaA3__"